import { gql } from '@apollo/client';

const GENERATE_OTP = gql`
  mutation GenerateOtp($msisdn: String!) {
    generateOtp(msisdn: $msisdn) {
      responseCode
      responseStatus
    }
  }
`;

export default GENERATE_OTP;
